import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { CityService } from '../../../_services/city.service';
import { ToastService } from '../../../_services/toast.service';
@Component({
  selector: 'app-delete-city',
  templateUrl: './delete-city.component.html',
  styleUrls: ['./delete-city.component.css']
})
export class DeleteCityComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private to_delete;

  constructor(private service: CityService, private toast: ToastService) { }

  ngOnInit() {
  }

  openModal(city_id){
    this.to_delete = city_id;
    jQuery('#delete-city-modal').modal({closable: false}).modal('show');
  }

  deleteCity(){
    if(!this.to_delete) { // Return false if the ID of the contact is not stored
      jQuery('#delete-city-modal').modal('hide');
      return false;
    } 
    let city_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the contact to delete (avoid spamming during the deletion process)
    jQuery('#delete-city-modal').modal({closable: false}); // Set the modal unclosable during the deletion process
    
    this.service.deleteCity(city_id) // Delete the Contact
      .subscribe(response => {
        console.log(response);
        jQuery('#delete-city-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      }, (error) => {
        console.log(error);
        jQuery('#delete-city-modal').modal('hide');
        this.toast.error(
          "Erreur lors de la suppression de la ville.",
          false,
          "Ville"
        );
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/city/delete-city/delete-city.component.ts